var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { computed, ref } from "vue";
import { getPermissions, isHistoryPrivate, makePrivate } from "@/components/History/services";
import { prependPath } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import SelectObjectStore from "@/components/ObjectStore/SelectObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectPreferredStore',
    props: {
        userPreferredObjectStoreId: {
            type: String,
            default: null,
        },
        history: {
            type: Object,
            required: true,
        },
    },
    emits: ["updated"],
    setup(__props, { emit }) {
        const props = __props;
        const error = ref(null);
        const selectedObjectStoreId = ref(props.history.preferred_object_store_id);
        const newDatasetsDescription = "New dataset outputs from tools and workflows executed in this history";
        const galaxySelectionDefaultTitle = "Use Galaxy Defaults";
        const galaxySelectionDefaultDescription = "Selecting this will reset Galaxy to default behaviors configured by your Galaxy administrator.";
        const userSelectionDefaultTitle = "Use Your User Preference Defaults";
        const userSelectionDefaultDescription = "Selecting this will cause the history to not set a default and to fallback to your user preference defined default.";
        const defaultOptionTitle = computed(() => {
            if (props.userPreferredObjectStoreId) {
                return userSelectionDefaultTitle;
            }
            else {
                return galaxySelectionDefaultTitle;
            }
        });
        const defaultOptionDescription = computed(() => {
            if (props.userPreferredObjectStoreId) {
                return userSelectionDefaultDescription;
            }
            else {
                return galaxySelectionDefaultDescription;
            }
        });
        function handleSubmit(preferredObjectStoreId, isPrivate) {
            return __awaiter(this, void 0, void 0, function* () {
                if (isPrivate) {
                    const { data } = yield getPermissions(props.history.id);
                    const permissionResponse = data;
                    const historyPrivate = yield isHistoryPrivate(permissionResponse);
                    if (!historyPrivate) {
                        if (confirm("Your history is set to create sharable datasets, but the target storage location is private. Change the history configuration so new datasets are private by default?")) {
                            try {
                                yield makePrivate(props.history.id, permissionResponse);
                            }
                            catch (_a) {
                                error.value = "Failed to update default permissions for history.";
                            }
                        }
                    }
                }
                const payload = { preferred_object_store_id: preferredObjectStoreId };
                const url = prependPath(`api/histories/${props.history.id}`);
                try {
                    yield axios.put(url, payload);
                }
                catch (e) {
                    error.value = errorMessageAsString(e);
                }
                selectedObjectStoreId.value = preferredObjectStoreId;
                emit("updated", preferredObjectStoreId);
            });
        }
        return { __sfc: true, props, error, selectedObjectStoreId, newDatasetsDescription, galaxySelectionDefaultTitle, galaxySelectionDefaultDescription, userSelectionDefaultTitle, userSelectionDefaultDescription, defaultOptionTitle, defaultOptionDescription, emit, handleSubmit, SelectObjectStore };
    }
});
